import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
//import { InterceptorService } from './interceptors/interceptor.service';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { DatePipe } from '@angular/common';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { PipeModule } from './pipes/pipe.module';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

import es from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { DemoMaterialModule } from './shared/demo.module';
import { SharedModule } from './shared/shared.module';
import { ImageModule } from './shared/components/image/image.module';
import { ImgCropperModule } from './shared/components/image-cropper/image-cropper.module';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatBadgeModule } from '@angular/material/badge';
import { ComponentsModule } from './components/components.module';
registerLocaleData(es);

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        PipeModule,
        DemoMaterialModule,
        ImgCropperModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatProgressBarModule,
        SharedModule, 
        ImageModule,

        CdkAccordionModule,
        FormsModule,
        ReactiveFormsModule,
        MatSidenavModule,
        MatInputModule,
        MatIconModule,
        MatListModule,
        MatMenuModule,
        MatToolbarModule,
        MatTabsModule,
        MatCheckboxModule,
        MatProgressBarModule,
        MatSelectModule,
        MatCardModule,
        MatBadgeModule,
        ComponentsModule,
        
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true
        },
        DatePipe,
        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
        { provide: LOCALE_ID, useValue: "es-ES" },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { disableClose: true, autoFocus: false, hasBackdrop: true } }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
